import { FIELD_TYPES } from "../constants/field-types";

export function fieldTypesGroupingPerOperation(rawData) {
  let groupedFieldTypes = {
    fieldTypes: [],
    fieldTypesAddForm: [],
    fieldTypesCloneForm: [],
    fieldTypesColumns: [],
    fieldTypesEditForm: [],
    fieldTypesReadForm: [],
    fieldTypesSearchColumns: [],
  };

  const fieldTypesMapping = {
    addFields: "fieldTypesAddForm",
    cloneFields: "fieldTypesCloneForm",
    columns: "fieldTypesColumns",
    editFields: "fieldTypesEditForm",
    readFields: "fieldTypesReadForm",
  };

  const readOnlyOperationsMapping = {
    fieldTypesAddForm: "readOnlyAddFields",
    fieldTypesEditForm: "readOnlyEditFields",
    fieldTypesCloneForm: "readOnlyCloneFields",
  };

  // Just adding some extra data to the default field types
  Object.keys(rawData.fieldTypes).forEach((fieldName) => {
    const fieldTypeData = rawData.fieldTypes[fieldName];

    if (fieldTypeData.dataType === FIELD_TYPES.INVISIBLE) {
      return true;
    }

    groupedFieldTypes.fieldTypes.push({
      fieldName: fieldName,
      ...fieldTypeData,
    });
  });

  Object.keys(fieldTypesMapping).forEach((fieldTypeName) => {
    const fieldTypeDataName = fieldTypesMapping[fieldTypeName];

    rawData[fieldTypeName].forEach((fieldData) => {
      const currentFieldTypeData = rawData[fieldTypeDataName][fieldData.name]
        ? rawData[fieldTypeDataName][fieldData.name]
        : rawData.fieldTypes[fieldData.name];

      // If the field is invisible we don't need to add it to the column field types
      if (
        fieldTypeDataName !== fieldTypesMapping.columns &&
        currentFieldTypeData.dataType === FIELD_TYPES.INVISIBLE
      ) {
        return true;
      }

      const currentGroupedFieldTypesData = {
        fieldName: fieldData.name,
        displayAs: fieldData.displayAs,
        ...currentFieldTypeData,
      };

      groupedFieldTypes[fieldTypeDataName].push(currentGroupedFieldTypesData);

      // When we are in the column field types we need to copy the field type data to fieldTypesSearchColumns as well
      // and overwrite the fieldType if exists at `rawData.fieldTypesSearchColumns`
      if (fieldTypeName === "columns") {
        if (rawData.fieldTypesSearchColumns[fieldData.name]) {
          groupedFieldTypes.fieldTypesSearchColumns.push({
            ...currentGroupedFieldTypesData,
            ...rawData.fieldTypesSearchColumns[fieldData.name],
          });
        } else {
          groupedFieldTypes.fieldTypesSearchColumns.push(
            currentGroupedFieldTypesData
          );
        }
      }
    });
  });

  Object.keys(readOnlyOperationsMapping).forEach((fieldTypeOperationName) => {
    const readOnlyOperationName =
      readOnlyOperationsMapping[fieldTypeOperationName];

    // For optimizing reason since usually we are not using readOnly fields
    if (rawData[readOnlyOperationName].length > 0) {
      groupedFieldTypes[fieldTypeOperationName].forEach(
        (fieldData, fieldName) => {
          if (rawData[readOnlyOperationName].includes(fieldData.fieldName)) {
            groupedFieldTypes[fieldTypeOperationName][
              fieldName
            ].isReadOnly = true;
          }
        }
      );
    }
  });

  return groupedFieldTypes;
}

export function addValuesToFieldTypes(fields, data) {
  let mergedFieldTypes = [];
  let dependencyFields = {};

  fields.forEach((field) => {
    switch (field.dataType) {
      case FIELD_TYPES.RELATIONAL:
      case FIELD_TYPES.RELATIONAL_NATIVE:
      case FIELD_TYPES.DEPENDED_RELATIONAL: {
        if (field.options && field.options.dependedFrom) {
          field.options.dependedFrom.forEach((dependencyField) => {
            dependencyFields[dependencyField] = true;
          });
        }

        break;
      }
      default: {
        dependencyFields[field.fieldName] = false;
        break;
      }
    }
  });

  fields.forEach((field) => {
    let fieldValue;
    let valueLabel = null;
    const { fieldName } = field;

    switch (field.dataType) {
      case FIELD_TYPES.RELATIONAL_N_N_NATIVE:
      case FIELD_TYPES.RELATIONAL_N_N_AND_ORDERING:
      case FIELD_TYPES.RELATIONAL_N_N: {
        fieldValue = data[fieldName] ? data[fieldName] : [];
        break;
      }
      case FIELD_TYPES.DEPENDED_RELATIONAL: {
        fieldValue = data[fieldName] ? data[fieldName].value : "";
        break;
      }
      case FIELD_TYPES.DYNAMIC_RELATION: {
        fieldValue = data[fieldName] ? data[fieldName].value : "";
        valueLabel = data[fieldName] ? data[fieldName].label : "";
        break;
      }
      default: {
        fieldValue = data[fieldName] ? data[fieldName] : "";
      }
    }

    mergedFieldTypes.push({
      ...field,
      isDependencyField: dependencyFields[fieldName] === true,
      fieldValue,
      valueLabel,
    });
  });

  return mergedFieldTypes;
}

export function formSubmitTransformation(data, formFields = []) {
  let dataToSubmit = {};

  // Just to save some loops, we are adding all the field types into an object for quick access
  let fieldTypesByFieldName = {};

  formFields.forEach((field) => {
    fieldTypesByFieldName[field.fieldName] = field.dataType;
  });

  Object.keys(data).forEach((fieldName) => {
    const fieldValue = data[fieldName];

    switch (fieldTypesByFieldName[fieldName]) {
      case FIELD_TYPES.MULTISELECT_NATIVE:
      case FIELD_TYPES.MULTISELECT_SEARCHABLE: {
        dataToSubmit[fieldName] = Array.isArray(fieldValue)
          ? fieldValue.join(",")
          : fieldValue;
        break;
      }

      case FIELD_TYPES.BACKEND_CALLBACK: {
        const fieldFromDom = document.querySelector(
          `.grocery-crud input[name=${fieldName}], .grocery-crud select[name=${fieldName}], .grocery-crud textarea[name=${fieldName}]`
        );
        if (fieldFromDom !== null) {
          dataToSubmit[fieldName] = fieldFromDom.value;
        } else {
          dataToSubmit[fieldName] = "";
        }
        break;
      }

      case FIELD_TYPES.BOOLEAN: {
        dataToSubmit[fieldName] = fieldValue ? "1" : "0";
        break;
      }

      default: {
        dataToSubmit[fieldName] = fieldValue;
        break;
      }
    }
  });

  return dataToSubmit;
}
